import { render, staticRenderFns } from "./_form.component.vue?vue&type=template&id=385aa85f&scoped=true&"
import script from "./_form.component.vue?vue&type=script&lang=js&"
export * from "./_form.component.vue?vue&type=script&lang=js&"
import style0 from "./_form.component.vue?vue&type=style&index=0&id=385aa85f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385aa85f",
  null
  
)

export default component.exports